import { render, staticRenderFns } from "./queryBtns.vue?vue&type=template&id=0f5224b2&"
import script from "./queryBtns.vue?vue&type=script&lang=js&"
export * from "./queryBtns.vue?vue&type=script&lang=js&"
import style0 from "./queryBtns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports